

<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="offset"
      :immediate-check="ischeck"
      finished-text="没有更多了"
      @load="loadMore"
    >
      <div v-for="item in dataList" :key="item.SerialNumber">
        <div v-if="item.DeceasedInformationList.length > 1">
          <router-link :to="{path:'/MemorialHall?id='+item.SerialNumber}" class="hall-item">
            <van-swipe class="my-swipe" :loop="false" indicator-color="orange">
              <van-swipe-item
                v-for="clientitem in item.DeceasedInformationList"
                :key="clientitem.id"
              >
                <div class="hall-list" >
                  <div class="bd">
                    <h2 class="sz-name">{{item.Title}}</h2>
                    <div class="sz-des">
                      <P>逝者: {{clientitem.DeceasedName}}</P>
                      <P>馆号: TT{{item.SerialNumber}}</P>
                      <P>建馆人: {{item.MemberName}}</P>
                      <P>创建时间: {{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</P>
                      <P>访问量: {{item.ClickCount}}</P>
                    </div>
                  </div>
                  <div class="ft">
                    <img v-bind:src="clientitem.PhotoPath" class="avatar" />
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
            <img src="@/assets/images/double_tag_icon.png" class="double-tag" />
          </router-link>
        </div>
        <div v-else>
          <router-link :to="{path:'/MemorialHall?id='+item.SerialNumber}"  class="hall-item">
            <div class="hall-list" >
              <div class="bd">
                <h2 class="sz-name">{{item.Title}}</h2>
                <div class="sz-des">
                  <P>逝者: {{item.DeceasedInformationList[0].DeceasedName}}</P>
                  <P>馆号: TT{{item.SerialNumber}}</P>
                  <P>建馆人: {{item.MemberName}}</P>
                  <P>创建时间: {{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</P>
                  <P>访问量: {{item.ClickCount}}</P>
                </div>
              </div>
              <div class="ft">
                <img :src="item.DeceasedInformationList[0].PhotoPath" class="avatar" />
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: []
    };
  },
  computed: {},
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "GetTodayTodayDeathBirthdayList",
        TodayType: 2,
        pageIndex: 1
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        res => {
          console.log(res);
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.TodayApiModelList;
          if (dataList.length <= 0) {
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } 
          else {
            that.dataList = dataList;
          }
        },
        error => {}
      );
    }
  },
  created() {
    var that = this;
    that.init();
  }
};
</script>

<style>
</style>